import { render, staticRenderFns } from "./PageActionMenu.vue?vue&type=template&id=978cb582"
import script from "./PageActionMenu.vue?vue&type=script&lang=js"
export * from "./PageActionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports